import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=544d079d&scoped=true"
import script from "./PluginList.vue?vue&type=script&lang=js"
export * from "./PluginList.vue?vue&type=script&lang=js"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=544d079d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d079d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544d079d')) {
      api.createRecord('544d079d', component.options)
    } else {
      api.reload('544d079d', component.options)
    }
    module.hot.accept("./PluginList.vue?vue&type=template&id=544d079d&scoped=true", function () {
      api.rerender('544d079d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/PluginList.vue"
export default component.exports